(function () {
  let swiperTestimonials;
  const initTestimonialsSlider = (section) => {
    if (!section || !section?.classList.contains("testimonials-section"))
      return;
    const swiperEl = section.querySelector(".testimonials-slider");
    const prevBtn = section.querySelector(".testimonials-nav-button--prev");
    const nextBtn = section.querySelector(".testimonials-nav-button--next");
    const columns = Number(swiperEl.dataset.slidesPerView) || 3;
    const isCenteredSlides = Boolean(swiperEl.dataset.centeredSlides);
    const isLoop = Boolean(swiperEl.dataset.loop);
    const breakpointsConfig = {
      1: {
        375: { slidesPerView: 1.15, spaceBetween: 20 },
        576: { slidesPerView: 1.25, spaceBetween: 20 },
        990: { slidesPerView: 1.25, spaceBetween: 24 },
      },
      2: {
        375: { slidesPerView: 1.15, spaceBetween: 20 },
        576: { slidesPerView: 1.25, spaceBetween: 20 },
        990: { slidesPerView: 1.5, spaceBetween: 24 },
        1360: { slidesPerView: 1.7, spaceBetween: 24 },
        1536: { slidesPerView: 2.25, spaceBetween: 24 },
      },
      3: {
        375: { slidesPerView: 1.15, spaceBetween: 20 },
        576: { slidesPerView: 1.25, spaceBetween: 20 },
        990: { slidesPerView: 2.1, spaceBetween: 24 },
        1360: { slidesPerView: 2.25, spaceBetween: 24 },
        1536: { slidesPerView: 3.15, spaceBetween: 24 },
      },
    };
    const sliderOptions = {
      slidesPerView: 1.1,
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
      loop: isLoop,
      centeredSlides: isLoop && isCenteredSlides,
      centeredSlidesBounds: isLoop && isCenteredSlides,
      breakpoints: breakpointsConfig[columns],
      mousewheel: {
        forceToAxis: true,
      },
      preventClicks: true,
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
    };
    swiperTestimonials = new Swiper(swiperEl, sliderOptions);
  };
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("testimonials-section"))
      return;
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initTestimonialsSlider(document.currentScript.parentElement);
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initTestimonialsSlider(event.target);
    initHeadingAnimation(event.target);
  });
})();
